import { connect, ConnectedProps } from 'react-redux'
import CustomError from '../../../../../../../../baseComponents/CustomError'
import { ModalLittle } from '../../../../../../../../baseComponents/Modal'
import { LittleModalCreateEditChildrenFirst } from '../../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { ModalEditComponentProps } from '../../../../../../../../baseComponents/ModalsLayouts/types'
import { permissionCheck } from '../../../../../../../../baseComponents/PermissionChecker/function'
import { FormRender } from '../../../../../../../../forms/FormRenderer/types'
import { checkIfCanCreateQuote } from '../../../../../../../../utils/globals/order/order'
import withLoading from '../../../../../../../../utils/hoc/withLoading'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import { AllReduxPayloads } from '../../../../../../../../utils/reducers'
import { WorkingCenterPayload } from '../../../../../../../../utils/reducers/company/workingCenters'
import { CustomerPayload } from '../../../../../../../../utils/reducers/customers/customer'
import { getSelectedWorkingCenter, getUserPermissions } from '../../../../../../../../utils/reducers/getters'
import { SupplierPayload } from '../../../../../../../../utils/reducers/products/suppliers'
import useCreateBuy from '../../../../../../../../utils/hooks/buys/orders/useCreateBuy'
import { BuyOrderModelTypeExtended } from '../../ModalCreateBuyOrder/types'
import { BillingGroupPayload } from '../../../../../../../../utils/reducers/company/billingGroups'
import locations from '../../../../../../../../utils/globals/locations'

interface ModalBuyOrderDuplicateProps extends ModalEditComponentProps { }

const ModalBuyOrderDuplicate: React.FC<ModalBuyOrderDuplicateProps> = ({ setOpened, ...rest }) => {
    const { t } = useTwinTranslation()
    const userPermissionsSupplier = getUserPermissions('supplier.main')
    if (!permissionCheck(userPermissionsSupplier, 'read')) {
        return <ModalLittle opened={true} setOpened={setOpened}>
            <h2 className='mb-25'>
                {t('newBuyOrder', 'Nuevo pedido de compra')}
            </h2>
            <CustomError textError={t('noPermissionsToSeeSuppliers', 'No tienes permisos para ver los proveedores')} />
        </ModalLittle>
    }
    return (
        <ModalBuyOrderDuplicateConnect setOpened={setOpened} {...rest} />
    )
}

type ModalBuyOrderDuplicateAfterPermissionsProps = ModalEditComponentProps & ReduxModalBuyOrderDuplicateConnector & {}

const ModalBuyOrderDuplicateAfterPermissions: React.FC<ModalBuyOrderDuplicateAfterPermissionsProps> = ({ userPermissions, allRowData, workingCenters, suppliers, customers, billingGroups, ...rest }) => {
    const { t } = useTwinTranslation()
    const workingCenter = getSelectedWorkingCenter()
    const { supplierInfo, customerInfo, createBuy, extraBillingTypesBuy, parseBTOBeforeSubmit, addressFields, mySupplierInfo } = useCreateBuy({ suppliers, customers, BillingGroupId: workingCenter?.BillingGroupId, baseURL: locations.buyOrderSingle })
    const error = checkIfCanCreateQuote(t, workingCenters?.[workingCenter?.id])
    const fields: FormRender<BuyOrderModelTypeExtended> = [
        {
            cols: 1,
            elements: [
                ...supplierInfo,
                ...mySupplierInfo,
                ...customerInfo,
                ...extraBillingTypesBuy,
                {
                    name: 'updatePrice',
                    label: t('updatePricesOfProducts', 'Actualizar precios de los productos'),
                    component: 'CheckboxMargin',
                    defaultChecked: true
                },
                {
                    name: 'updateCopyProduct',
                    label: t('updateNameAndDescriptions', 'Actualizar nombre y descripción de los productos'),
                    component: 'CheckboxMargin',
                    defaultChecked: true
                },
                {
                    name: 'copyNotes',
                    label: t('copyNotes', 'Copiar notas'),
                    component: 'CheckboxMargin',
                    defaultChecked: true
                },
                {
                    name: 'CurrencyId',
                    component: 'InputHidden',
                    value: workingCenter?.CurrencyId
                },
                {
                    name: 'WorkingCenterId',
                    component: 'InputHidden',
                    value: workingCenter?.id
                },
                {
                    name: 'OrderId',
                    component: 'InputHidden',
                    value: allRowData?.header?.id
                }
            ]
        },
        ...addressFields,
    ]
    return (
        <LittleModalCreateEditChildrenFirst fields={error ? [] : fields} url={'/api/app/order/buy/buyOrder/createBuyOrder'} translations={{
            title: t('newBuyOrder', 'Nuevo pedido de compra'),
            button: t('create', 'Crear')
        }} haveButtonPermissions={!error} beforeSubmit={parseBTOBeforeSubmit}  {...{ ...rest, onSubmit: createBuy }}>
            {error ? <CustomError textError={error} /> : null}
        </LittleModalCreateEditChildrenFirst>)
}

const modalBuyOrderDuplicateDispatch = {
    setWorkingCenters: (payload: WorkingCenterPayload) => ({ type: 'CHANGE_WORKINGCENTER', payload }),
    setSuppliers: (payload: SupplierPayload) => ({ type: 'CHANGE_SUPPLIER', payload }),
    setCustomers: (payload: CustomerPayload) => ({ type: 'CHANGE_CUSTOMER', payload }),
    setBillingGroups: (payload: BillingGroupPayload) => ({ type: 'CHANGE_BILLINGGROUP', payload }),
}
const mapModalBuyOrderDuplicateConnector = (state: AllReduxPayloads) => ({ workingCenters: state.workingCenters, suppliers: state.suppliers, customers: state.customers, billingGroups: state.billingGroups })
const modalBuyOrderDuplicateConnector = connect(mapModalBuyOrderDuplicateConnector, modalBuyOrderDuplicateDispatch)
type ReduxModalBuyOrderDuplicateConnector = ConnectedProps<typeof modalBuyOrderDuplicateConnector>

const modalBuyOrderDuplicateConnectLoading = withLoading(ModalBuyOrderDuplicateAfterPermissions, [{ fetchUrl: '/api/app/supplier/getAllSuppliers', propName: 'suppliers', setFunctionName: 'setSuppliers' }, { fetchUrl: '/api/app/customer/getAllCustomers', propName: 'customers', setFunctionName: 'setCustomers' }, { fetchUrl: '/api/app/workingCenter/getAllWorkingCentersComplete', propName: 'workingCenters', setFunctionName: 'setWorkingCenters' }, { fetchUrl: '/api/app/config/billingGroup/getAllBillingGroupsComplete', propName: 'billingGroups', setFunctionName: 'setBillingGroups' }])
const ModalBuyOrderDuplicateConnect = modalBuyOrderDuplicateConnector(modalBuyOrderDuplicateConnectLoading)


export default ModalBuyOrderDuplicate